import { render } from "./plan-c.vue?vue&type=template&id=9c68f458"
import script from "./plan-c.vue?vue&type=script&lang=js"
export * from "./plan-c.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__